import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	listItemIcon: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		color: colors.gray[700],
		minWidth: 45
	},
	listItemActive: {
		position: "relative",
		"&:before": {
			position: "absolute",
			content: "close-quote",
			width: "4px",
			height: "100%",
			left: 0,
			top: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
		}
	},
	menuItem: {
		width: "100%"
	},
	disabledMenuItem: {
		opacity: "0.5 !important"
	},
	newFeatureListItemText: {
		flex: "none"
	},
	listItemMenuLine: {
		display: "flex",
		flexDirection: "row"
	},
	tooltipInfoIcon: {
		marginRight: 16,
		width: 16,
		heigth: 16
	}
}))

export default useStyles
